<template>
	<thead>
		<tr class="row">
			<th v-for="col in columns" :key="col.column || col.label" class="column">
				<p class="column__label">{{ col.label }}</p>
			</th>
		</tr>
	</thead>
</template>

<script>
export default {
	name: 'StrapiTableHeader',
	props: {
		columns: Array,
		validator: v => v.every(i => i.column || i.label)
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';

.row {
	background-color: $grey-95;
}

.column {
	&__label {
		color: $black;
		text-decoration: none;
		text-transform: uppercase;
	}
}
</style>
